import React, { useContext, useEffect, useState } from 'react';
import './RangeSlider.style.css';

import Slider from '@material-ui/core/Slider';
import { FilterContext } from '../../contexts/FilterContext';

export default function RangeSlider() {
	const [filters, setFilters] = useContext(FilterContext);
	const [yearSpan, setYearSpan] = useState<number[]>([]);

	const handleChange = () => {
		setFilters({ ...filters, yearSpan });
	};

	useEffect(() => {
		setYearSpan(filters.yearSpan);
	}, [filters]);

	return (
		<div className="range-slider">
			<Slider
				min={1810}
				max={2022}
				value={yearSpan}
				onChange={(event: any, newValue: any) => setYearSpan(newValue)}
				onChangeCommitted={handleChange}
				valueLabelDisplay="auto"
			/>
			<div className="slider-range-label">
				<span>År 1810</span>
				<span>År 2022</span>
			</div>
		</div>
	);
}
